import { ITEM_STATUSES } from '@updater-core/constants/items';
import { createStore } from '@updater-core/lib/store';
import { waitFor } from '@updater-core/lib/async';
import { PackingSuppliesState } from './types';
import * as actions from './actions';

import * as selectors from './selectors';

export const STORAGE_KEY = 'upd.packingsupplies';

function convertHomeSize(homeSize: string): string {
  if (
    [
      'studio',
      'one_bed',
      'two_bed',
      'three_bed',
      'four_bed',
      'five_bed',
    ].includes(homeSize)
  ) {
    return homeSize;
  }
  if (homeSize === 'three_bed_plus') {
    return 'three_bed';
  }
  if (homeSize === 'four_bed_plus') {
    return 'four_bed';
  }
  return '';
}
export default function createInteractor({
  session,
  moveItems,
  currentFormIndex,
  gateways: { storage },
}) {
  const sessionState = session.getState();
  const newFormData = selectors.formData(sessionState); // get this from server side
  const initialState: PackingSuppliesState = {
    currentFormIndex,
    moveId: session.selectors.currentMoveId(sessionState),
    homeSize: convertHomeSize(session.selectors.fromHomeSize(sessionState)),
    ...newFormData,
  };

  const store = createStore<PackingSuppliesState>(initialState, []);

  storage.subscribeJSON(STORAGE_KEY, async ({ newValue }) => {
    if (newValue) {
      const { debugChange, ...newState } = newValue;
      if (debugChange) {
        store.setState(newState);
      }
    }
  });

  return {
    ...store,
    experimentInitialized: waitFor(
      store,
      (state) => state.loadingExperiment === false
    ),
    actions: {
      init: actions.init({
        store,
      }),
      submit: actions.submit({
        store,
        moveItems,
      }),
      update: actions.update({ store }),
      navigateTo: actions.navigateTo({ store }),
      markStepAsStarted: actions.markStep({
        store,
        actions: moveItems.actions,
        status: ITEM_STATUSES.STARTED,
      }),
      markStepAlreadyDone: actions.markStep({
        store,
        actions: moveItems.actions,
        status: ITEM_STATUSES.ALREADY_DONE,
      }),
      markStepCompleted: actions.markStep({
        store,
        actions: moveItems.actions,
        status: ITEM_STATUSES.COMPLETED,
      }),
      initializeVariation: actions.initializeVariation({ store }),
      initializeIntroPageVariation: actions.initializeIntroPageVariation({
        store,
      }),
      initializeEntryPointVariation: actions.initializeEntryPointVariation({
        store,
      }),
      initializeStarterKitVariation: actions.initializeStarterKitVariation({
        store,
      }),
    },
    selectors: {
      formData: selectors.formData,
      packingSuppliesStatus: selectors.packingSuppliesStatus,
      packingSuppliesVariation: selectors.packingSuppliesVariation,
      introPageVariation: selectors.introPageVariation,
      entryPointVariation: selectors.entryPointVariation,
      starterKitVariation: selectors.starterKitVariation,
    },
  };
}
